import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './InfrastructureWrapper.css';
import { Layout } from '../../Layout';

export interface IInfrastructureWrapperProps {
  headerLinks: React.ReactNode;
  title: string;
}

export const InfrastructureWrapper: React.FC<React.PropsWithChildren<IInfrastructureWrapperProps>> = ({
  headerLinks,
  title,
  children,
}) => {
  return (
    <section className={styles['wrapper']} data-nav-tab="infrastructure/Расположение" id="infrastructure">
      <Layout>
        <div className={styles['header']}>
          <ArticleHeading1 as="h2" fontWeight="bold">
            {title}
          </ArticleHeading1>
          <span className={styles['links']}>{headerLinks}</span>
        </div>
      </Layout>
      {children}
    </section>
  );
};
